import React from 'react'
import Section1 from './Section1/Section1'

export default function Blogs() {
  return (
    <div className='w-full px-4 lg:px-[70px] overflow-hidden'>
      <Section1/>
    </div>
  )
}
